import React from "react";
import PropTypes from "prop-types";

// material-ui components
import IconCard from "components/Cards/IconCard";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";

function RequirementsCard({ ...props }) {
  const {
    content,
  } = props;

  return (
    <IconCard
      title="User Requirements"
      iconColor="blue"
      icon={Assignment}
      content={<div dangerouslySetInnerHTML={{__html:content}}></div>}
    />
  );
}

IconCard.defaultProps = {
};

IconCard.propTypes = {
  content: PropTypes.node,
};

export default RequirementsCard;




// WEBPACK FOOTER //
// ./src/components/Cards/RequirementsCard.jsx